import AreaDirectorSortableDigitalJobsList from "../react/AreaDirectorSortableDigitalJobsList";

export default class DigitalJobsAreaDirector {
  perform() {
    this.buildList("my", this.jobsData("my"), "Date Modified");
    this.buildList("posted", this.jobsData("posted"), "Redesign Date");
  }

  jobsData(ele) {
    const raw = $(`.js-digital-ads-react-data-${ele}`);

    if (raw.length) {
      return raw.data("jobs");
    }

    return [];
  }

  buildList(ele, jobsData, dateColumn) {
    if (jobsData.length) {
      const list = new AreaDirectorSortableDigitalJobsList({
        sortScope: `#sort-filters-${ele}`,
        selector: `.js-digital-ads-list-${ele}`,
        data: jobsData,
        dateColumnTitle: dateColumn,
        roleType: "area_director",
      });

      list.render();
    }
  }
}
